import { render, staticRenderFns } from "./CreateCosting.vue?vue&type=template&id=54d9c8cb"
import script from "./CreateCosting.vue?vue&type=script&lang=js"
export * from "./CreateCosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports